<app-header  ></app-header>

<div class="container">
        <div class="centered text-center">
            <h3> Dispositivos</h3>
            
        </div>
</div>

<div class="container">
  
    <div class="row"> 
        <div class="container"  *ngIf="sendCommand">
                <div class="centered text-center">
                        <h5>Enviando comando</h5>
                        <dx-load-indicator   height="60" width="60"></dx-load-indicator>
                </div>
        </div>
        <div class="container" *ngIf="!sendCommand">
            <div class="label centered">
                <h4>Comandos: </h4>
            </div>
            <dx-menu
                #menu
                [dataSource]="commands"
                displayExpr="name"
                [showFirstSubmenuMode]="showFirstSubmenuModes"
                orientation="horizontal"
                submenuDirection="auto"
                [hideSubmenuOnMouseLeave]="false"
                (onItemClick)="itemClick($event)" >
            </dx-menu> 
        </div> 

        <dx-data-grid id="idgrid" class="table table-hover"
                      [dataSource]="dataSource"
                      [showBorders]="true"
                      [remoteOperations]="true" 
                                (onEditingStart)="logEvent('EditingStart',$event)"
                                 (onInitNewRow)="logEvent('InitNewRow',$event)"
                                 (onRowInserting)="logEvent('RowInserting',$event)"
                                 (onRowInserted)="logEvent('RowInserted',$event)"
                                 (onRowUpdating)="logEvent('RowUpdating',$event)"
                                 (onRowUpdated)="logEvent('RowUpdated',$event)"
                                 (onRowRemoving)="logEvent('RowRemoving',$event)"
                                 (onRowRemoved)="logEvent('RowRemoved',$event)"
                                 (onSelectionChanged)="logEvent('eventSelect',$event)"
                                 (onCellClick)="onCellClick($event)" >
                                 <!-- [showColumnHeaders]="false" -->
                                 <!-- [columns]="['deviceSN', 'deviceName', 'State', 'Phone', 'Fax']" -->
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-selection
            [selectAllMode]="allMode"
            [showCheckBoxesMode]="checkBoxesMode" mode="multiple" ></dxo-selection>

            <dxo-pager [showPageSizeSelector]="10"
                        [allowedPageSizes]="[10,20]"
                        [showInfo]="true" ></dxo-pager>
            <dxo-column-chooser
                        [enabled]="true"
                        mode="select"> <!-- or "select","dragAndDrop" -->
            </dxo-column-chooser>
         
                        <!-- Agregar en la misma tabla en la fila -->
            <!-- <dxo-editing mode="row"
                         [allowUpdating]="true"
                         [allowAdding]="true">-->
            <dxo-export [enabled]="true" fileName="Dispositivos"  [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row> 
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-editing mode="popup" [allowUpdating]="true"  [allowAdding]="true"> 
             
                <dxo-popup title="Información del dispositivo"
                            [showTitle]="true"
                            [width]="700"
                            [height]="420"
                            [position]="{ my: 'top', at: 'top'}">
                </dxo-popup>
            </dxo-editing>
            <dxi-column dataField="deviceSN" caption="Numero de serie"  
             [width]="140" 
            [editorOptions]="{ disabled: editorOptions }"></dxi-column>
            <dxi-column dataField="deviceName" caption="Nombre"   [width]="180"></dxi-column>
            <dxi-column dataField="ipAddress" caption="Direccion-IP" headerCellTemplate="IP"
            [editorOptions]="{ disabled: true }"   [width]="100"></dxi-column>
            <dxi-column dataField="lastActivity" caption="Conexión" headerCellTemplate="Conexión"
            [editorOptions]="{ disabled: true }" [width]="190" ></dxi-column>
            <dxi-column dataField="state" caption="Estatus" headerCellTemplate="Estatus"
            [editorOptions]="{ disabled: true }" [width]="90"></dxi-column>
            <dxi-column dataField="firmwareVersion" caption="F. Versión" headerCellTemplate="F. Versión"
            [editorOptions]="{ disabled: true }"></dxi-column>
            <dxi-column dataField="transCount" caption="Récords" headerCellTemplate="Récords"
            [editorOptions]="{ disabled: true }"></dxi-column>
            <dxi-column dataField="userCount" caption="Usuarios" headerCellTemplate="Usuarios"
            [editorOptions]="{ disabled: true }"></dxi-column>
            <dxi-column dataField="fpCount" caption="Huellas" headerCellTemplate="Huellas"
            [editorOptions]="{ disabled: true }"></dxi-column>
            <dxi-column dataField="timeZone" caption="Zona Horaria. UTC-" headerCellTemplate="Zona Horaria"
            [editorOptions]="{ disabled: true }"></dxi-column>
            <!-- <dxi-column dataField="Modelo" caption="Position" headerCellTemplate="Récords">-->
        </dx-data-grid> 
    </div>  
</div>
 
<!-- para formaulario de Records de Attlog por fechas -->
<div class="row">
        <dx-popup class="popup" [width]="600" [height]="350" [showTitle]="true"
        title="{{popupTitle}}" [dragEnabled]="false" [closeOnOutsideClick]="true"
            [(visible)]="popupAttlogVisible">
                <div *dxTemplate="let data of 'content'">
                       <div class="container">
                        <h1>Fechas </h1>
                        <form #theForm = "ngForm"  autocomplete="false">
                            <div class="dx-field" *ngIf="!rdAttLog">
                                Borrar registros con más de 90 días de antigüedad
                            </div>
                            <div class="dx-field" *ngIf="rdAttLog">
                              <div class="dx-field-label">Traer registros de los últimos:</div>
                              <dx-lookup
                                  [(ngModel)]="periodo"
                                  name= "periodo"
                                  [value]="periodo"
                                  [dataSource]="periodos"
                                  placeholder="Select an item" 
                                  displayExpr="Name"
                                  valueExpr="ID"
                                  class="dx-field-value">
                              </dx-lookup>
                            </div> 
                                <!--div class="dx-field">
                                        <div class="dx-field-label">Fecha incio</div>
                                        <div class="dx-field-value">
                                            <dx-date-box
                                                [value]="attlogCommand.startTime"
                                                type="date"
                                                name="startTime"
                                                displayFormat="d/MM/yyyy"
                                                [disabled]="fiDisabled"
                                                [(ngModel)]="attlogCommand.startTime" 
                                                (onValueChanged)="onValueChangedDateStart($event)" >
                                            </dx-date-box>
                                        </div>
                                </div>

                                <div class="dx-field">
                                        <div class="dx-field-label">Fecha fin</div>
                                        <div class="dx-field-value">
                                            <dx-date-box
                                                [value]="attlogCommand.endTime"
                                                type="date"
                                                name="endTime"
                                                displayFormat="d/MM/yyyy"
                                                [disabled]="ffDisabled"
                                                [(ngModel)]="attlogCommand.endTime" 
                                                (onValueChanged)="onValueChangedDateEnd($event)" >
                                            </dx-date-box>
                                        </div>
                                </div-->
                                <div class="footer-copyright text-left py-3">
                                    <div class="dx-field">
                                            <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  
                                            (click)="onAttLogCommand()"
                                                [disabled]="theForm.invalid" *ngIf="popupcmd == 'attlog'">
                                                    Traer Registros 
                                            </button>
                                            <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  
                                            (click)="onAttLogCommand()"
                                                [disabled]="theForm.invalid" *ngIf="popupcmd == 'delLog'">
                                                    Borrar Registros 
                                            </button>
                                    </div>
                                </div> 
                            </form>
                        </div>
                </div>
        </dx-popup>
</div>



<!-- formulario para cambiar zona horaria -->
<div class="row">
    <dx-popup class="popup" [width]="600" [height]="350" [showTitle]="true"
        title="Cambio de zona horaria" [dragEnabled]="false" [closeOnOutsideClick]="true"
        [(visible)]="popupTimeZone">
            <div *dxTemplate="let data of 'content'">
                   <div class="container">
                    <h1>Zona horaria </h1>
                    <form #theForm = "ngForm"  autocomplete="false">
                        <div class="dx-field">
                            <div class="dx-field-label">UTC</div>
                            <div class="dx-field-value">
                                <dx-number-box 
                                    [value]="timeZone"
                                    [min]="-11"
                                    [max]="13"
                                    [(ngModel)]="timeZone"
                                    name="timeZone" >
                                </dx-number-box>  
                            </div> 
                        </div> 
                            <div class="footer-copyright text-left py-3">
                                <div class="dx-field">
                                        <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  
                                        (click)="onTimeZoneCommand()"
                                            [disabled]="theForm.invalid" >
                                                Enviar 
                                        </button>
                                </div>
                            </div> 
                        </form>
                    </div>
            </div>
    </dx-popup>
</div>


<app-footer></app-footer>